<template>
  <div class="p-register-nav">
    <Button
      v-if="hasProject"
      :to="{
        name: 'projects'
      }"
      variant="light"
      icon="pageback"
      radius
    >
      サイト一覧に戻る
    </Button>
    <Button
      v-if="!hasProject"
      variant="light"
      class="logout"
      radius
      @click="logout"
    >
      ログアウト
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  props: ['hasProject'],

  components: {
    Button
  },

  methods: {
    logout() {
      this.auth.logout();
    }
  }
};
</script>
